import type { FC } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    className?: string
    tone?: 'light' | 'dark'
}

/** The K mark: a stem, a leg, and an arm that throws a ball. */
export const LogoMark: FC<LogoMarkProps> = ({ className }) => {
    return (
        <svg viewBox='0 0 32 32' className={cn('shrink-0', className)} aria-hidden='true'>
            <rect width='32' height='32' rx='9' className='fill-ember' />
            <path d='M10.6 8.6v14.8' stroke='#08080A' strokeWidth='3.2' strokeLinecap='round' />
            <path d='M11.2 18.1 19 10.3' stroke='#08080A' strokeWidth='3.2' strokeLinecap='round' />
            <path d='M15.4 15.4 21.4 23.4' stroke='#08080A' strokeWidth='3.2' strokeLinecap='round' />
            <circle cx='22.6' cy='7.9' r='2.3' fill='#08080A' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, tone = 'light' }) => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark className='size-7' />
            <span className={cn('text-[19px] font-semibold leading-none tracking-[-0.035em]', tone === 'light' ? 'text-bone' : 'text-ink')}>
                kinematic
            </span>
        </span>
    )
}
